<template>
  <div class="space-y-8">
    <div class="flex space-x-2">
      <BaseButton primary small @click="currentModal = 'OrderItemAttachmentLinkCreateModal'">
        Add Link
      </BaseButton>
      <BaseButton primary small @click="currentModal = 'OrderItemAttachmentNoteCreateModal'">
        Add Note
      </BaseButton>
      <BaseButton primary small @click="currentModal = 'OrderItemAttachmentMediaCreateModal'">
        Add Media
      </BaseButton>
      <BaseButton primary small @click="currentModal = 'OrderItemAttachmentAssetCreateModal'">
        Add from Asset
      </BaseButton>
    </div>
    <ul v-if="attachments.length" class="grid grid-cols-3 gap-3">
      <li v-for="attachment in attachments" :key="`${attachment.type}_${attachment.id}`">
        <AttachmentTile v-bind="attachment" :on-delete-attachment="handleAttachmentDelete" />
      </li>
    </ul>
    <div v-else class="border-2 border-dashed rounded flex items-center justify-center h-24">
      No attachents yet.
    </div>

    <portal to="app-dialog">
      <OrderItemAttachmentLinkCreateModal
        v-if="currentModal === 'OrderItemAttachmentLinkCreateModal'"
        :order-item-id="orderItemId"
        @created="finishCreated"
        @closed="currentModal = null"
      />
      <OrderItemAttachmentNoteCreateModal
        v-if="currentModal === 'OrderItemAttachmentNoteCreateModal'"
        :order-item-id="orderItemId"
        @created="finishCreated"
        @closed="currentModal = null"
      />
      <OrderItemAttachmentMediaCreateModal
        v-if="currentModal === 'OrderItemAttachmentMediaCreateModal'"
        :order-item-id="orderItemId"
        @created="finishCreated"
        @closed="currentModal = null"
      />
      <OrderItemAttachmentAssetCreateModal
        v-if="currentModal === 'OrderItemAttachmentAssetCreateModal'"
        :account-id="accountId"
        :client-id="clientId"
        :order-item-id="orderItemId"
        @created="finishCreated"
        @closed="currentModal = null"
      />
    </portal>
  </div>
</template>

<script>
import { sortBy } from 'lodash-es';
import { orderItemLinksClient, orderItemNotesClient, orderItemMediaClient } from '@/api/clients';
import AttachmentTile from './AttachmentTile.vue';
import OrderItemAttachmentLinkCreateModal from './OrderItemAttachmentLinkCreateModal.vue';
import OrderItemAttachmentNoteCreateModal from './OrderItemAttachmentNoteCreateModal.vue';
import OrderItemAttachmentMediaCreateModal from './OrderItemAttachmentMediaCreateModal.vue';
import OrderItemAttachmentAssetCreateModal from './OrderItemAttachmentAssetCreateModal.vue';

export default {
  name: 'AttachmentsTab',

  components: {
    AttachmentTile,
    OrderItemAttachmentLinkCreateModal,
    OrderItemAttachmentNoteCreateModal,
    OrderItemAttachmentMediaCreateModal,
    OrderItemAttachmentAssetCreateModal,
  },

  props: {
    accountId: {
      type: String,
      required: true,
    },
    clientId: {
      type: String,
      required: true,
    },
    orderItemId: { type: String, required: true },
    links: { type: Array, default: () => [] },
    notes: { type: Array, default: () => [] },
    media: { type: Array, default: () => [] },
  },

  data() {
    return {
      currentModal: null,
    };
  },

  created() {
    this.fetchAttachments();
  },

  computed: {
    attachments() {
      return sortBy(
        [
          ...this.links.map(({ id, url, title, description, cover = null, createdAt }) => ({
            type: 'links',
            id,
            attributes: {
              url,
              title,
              description,
              cover,
              createdAt,
            },
          })),
          ...this.notes.map(({ id, content, createdAt }) => ({
            type: 'notes',
            id,
            attributes: {
              content,
              createdAt,
            },
          })),
          ...this.media.map(({ id, url, mimeType, name, createdAt }) => ({
            type: 'media',
            id,
            attributes: {
              name,
              url,
              mimeType,
              createdAt,
            },
          })),
        ],
        (attachment) => attachment.attributes.createdAt
      );
    },
  },

  methods: {
    async fetchAttachments() {
      try {
        await this.$store.dispatch({
          type: 'ui/orderItems/read',
          orderItemUuid: this.orderItemId,
          params: {
            include: 'links,notes,media',
          },
        });

        this.$emit('changed');
      } catch (error) {
        //
      }
    },
    async handleAttachmentDelete({ type, id }) {
      try {
        let response = null;

        if (type === 'links') {
          response = await orderItemLinksClient.destroy(this.orderItemId, id);
        }
        if (type === 'notes') {
          response = await orderItemNotesClient.destroy(this.orderItemId, id);
        }
        if (type === 'media') {
          response = await orderItemMediaClient.destroy(this.orderItemId, id);
        }

        if (response) {
          await this.$store.dispatch('entities/persistEntities', {
            type: 'orderItems',
            data: response.data.data,
          });
        }

        this.$emit('changed');
      } catch (error) {
        //
      }
    },
    finishCreated() {
      this.currentModal = null;
      this.$emit('changed');
    },
  },
};
</script>
